/* eslint-disable */

import React, { useState, useEffect, useRef } from 'react'
import SideBar from '../components/views/SideBar'

import axios from 'axios'
import { useLocation, Link } from 'react-router-dom'

import { Base64 } from 'js-base64'
import ReactHtmlParser from 'react-html-parser'
import Sign from '../assets/img/signOnly.png'
import Hnin from '../assets/img/hnin.png'
import DrAP from '../assets/img/DrAP.png'
import WinLabLogo from '../assets/img/cropped-winlab.png'
import WinLabLogo1 from '../assets/img/win-lab-letter-head.png'
import styled, { keyframes } from 'styled-components'
import apiInstance from '../utils/api'
import ConfirmResultDialog from './confirmResultDialog'
import calculateAge from '../features/autoIncreaseAge'
// import Printer from "@eyelly/react-printer";
const formatDate = (dateString) => {
  const date = new Date(dateString);
  const day = date.getDate(); // gets 1–31
  const month = date.toLocaleString('en-US', { month: 'short' }); // "Apr"
  const year = date.getFullYear();

  return `${day}-${month}-${year}`;
};
const TestVoucherPrint = () => {
  const [referDoctorLists, setReferDoctorLists] = useState([])
  const [selectedPatho, setSelectedPatho] = useState('')
  const [voucherLists, setVoucherLists] = useState([])
  const [filteredVouchers, setFilteredVouchers] = useState([])

  const [patientLists, setPatientLists] = useState([])

  const [labID_VouCode, setLabID_VouCode] = useState([])
  const [PRDate, setRPDate] = useState("")
  const [headerOn, setHeaderOn] = useState(true)
  const [refOn, setRefOn] = useState(true)
  const [resOn, setResOn] = useState(true)
  const [textArea, settextArea] = useState('')
  const [showBottom, setShowBottom] = useState(false)
  const [showDialog, setShowDialog] = useState(false)
  // const [headerOff, setHeaderOff] = useState(false);
  const [isPrint, setIsPrint] = useState(false);
  const TR = styled.tr`
    font-size: 20px;
    margin-top: 16px;

    border-style: hidden;
  `
  const TH1 = styled.th`
    font-size: 25px;
    margin-bottom: 1px;
    padding: 1px;
    font-weight:bold;
  `
  const TD1 = styled.td`
    font-size: 22px;
    margin-bottom: 1px;
    padding: 1px;

  `

  const SPAN = styled.span`
    font-size: 20px;
  `
  const P = styled.p`
    color: white;
  `
  let componentRef = useRef()

  // const getContentSize = () => {
  //   const contentElement = componentRef.current;
  //   const contentRect = contentElement.getBoundingClientRect();
  //   const { width, height } = contentRect;
  //   return { width, height };
  // };

  const handleShowModalBox = () => {
    setShowDialog(true)
  }
  const handleOnCheck = () => {
    setHeaderOn(true)
  }

  const handleOffCheck = () => {
    setHeaderOn(false)
  }
  const RefOnCheck = () => {
    setRefOn(true)
  }

  const RefOffCheck = () => {
    setRefOn(false)
  }
  const ResOnCheck = () => {
    setResOn(true)
  }

  const ResOffCheck = () => {
    setResOn(false)
  }
  function decodeBase64(data) {
    const decode = Base64.decode(data)

    return decode
  }

  const clickHandler = (event) => {
    if (event.detail == 2) {
      document.getElementById(event.target.value).tagName.name = "input";
      console.log("Double Clicked")
    }
  }

  const handleBottomChange = event => {
    // setShowBottom(false);
    // document.getElementById("printtop").style.marginTop = "50px";


    // document.getElementById("printtop").style.position = "running(footer)";
    // document.getElementById("printtop").classList.add("fixed-bottom");
    //document.getElementById("printtop").style.bottom= "0";
    let printContents = document.getElementById('print').innerHTML;
    let originalContents = document.body.innerHTML;
    document.body.innerHTML = printContents;
     const images = document.querySelectorAll('img');
  const imagePromises = Array.from(images).map(img => {
    return new Promise(resolve => {
      if (img.complete) {
        resolve();
      } else {
        img.onload = resolve;
        img.onerror = resolve; // Still resolve on error
      }
    });
  });

  Promise.all(imagePromises).then(() => {
    window.print();
    document.body.innerHTML = originalContents;
    window.location.reload();
  });
    // window.print();

  }

  const handleChange = event => {
    setShowBottom(!showBottom)
    if (event.target.checked) {
      voucherLists.map(vou => {
        if (vou._id === event.target.value) {
          setFilteredVouchers([...filteredVouchers, vou])
          console.log([...filteredVouchers, vou])
        }
      })
    } else {
      if (filteredVouchers.length > 0) {
        setFilteredVouchers(
          filteredVouchers.filter(vou => vou._id !== event.target.value)
        )
      }
    }
    //setIsSubscribed(current => !current);
  }
  // end

  // change /br to line brake format
  function formatString(data) {
    const base64String = decodeBase64(data)
    const reactElements = ReactHtmlParser(base64String)

    return reactElements
  }
  // end
  const TestVou_id = useLocation().pathname.split('/')[2]

  // var og_date = labID_VouCode.date;
  // console.log(og_date.split("T"));
  // const sampleStr = 'Hello world';
  // console.log(sampleStr.split(' '));
  // const Regdate = labID_VouCode.date;

  const handlePathoChange = value => {
    console.log(value, 'doc id')
    if (value) {
      referDoctorLists.map((doctor, index) => {
        if (doctor._id === value) {
          setSelectedPatho(doctor)
        }
      })
    }

  }

  useEffect(() => {
    const getVoucherList = async () => {
      try {
        const res = await apiInstance.get(
          'voucher/' +
          // 'http://localhost:9000/api/voucher/' +
          TestVou_id
        )

        // console.log(vouDate);
        setVoucherLists(res.data.data.testSelection)
        //setFilteredVouchers(res.data.data.testSelection)
        settextArea(res.data.data.comment)
        setLabID_VouCode(res.data.data)
        console.log(res.data.data, 'resultPrint')

        // console.log(res.data.data.testSelection[0].name.specialComment);

        // console.log(res.data.data.testSelection[0].result);
      } catch (err) {
        alert('Error')
      }
    }

    const getPatientList = async () => {
      try {
        const res = await apiInstance.get(
          'voucher/' +
          TestVou_id
        )

        setPatientLists(res.data.data.relatedPatient)
      } catch (err) {
        alert('Error')
      }
    }

    const getReferDoctorList = async () => {
      try {
        const res = await apiInstance.get(
          'pathologists'
        )

        setReferDoctorLists(res.data.data)
        setSelectedPatho(res.data.data[0])
        // console.log(res.data.data)
      } catch (err) {
        alert('Error')
      }
    }

    getReferDoctorList()
    getPatientList()
    getVoucherList()
  }, [])
  const hasImage = filteredVouchers.some(testSelect => testSelect.img);
  console.log(filteredVouchers, 'filteredVouchers')


  useEffect(() => {
    const mediaQuery = window.matchMedia("print");

    const beforePrint = () => setIsPrint(true);
    const afterPrint = () => setIsPrint(false);

    window.addEventListener("beforeprint", beforePrint);
    window.addEventListener("afterprint", afterPrint);

    return () => {
      window.removeEventListener("beforeprint", beforePrint);
      window.removeEventListener("afterprint", afterPrint);
    };
  }, []);
  return (

    <div className='wrapper'>
      <SideBar />
      {/* <!-- Content Wrapper. Contains page content --> */}

      <div className='content-wrapper ' >
        {/* <!-- Content Header (Page header) --> */}
        <div className='content-header'>
          <div className='container-fluid '>
            <div
              className="print-content"
            // calssName='card content'
            // style={{ maxWidth: "700px", marginLeft: "170px" }}
            >
              <div id="print" className="h-100 d-flex flex-column" ref={componentRef}>
                <div
                  className='print-wrapper d-flex flex-column flex-grow-1'
                // style={{ border: '1px solid black', padding: '14px 14px' }}
                >
                  <div className='print-header'>
                    {/* ===== HEADER ===== */}

                    {headerOn ? (
                      <div className='row w-full p-0 m-0 mb-4'>
                        <img src={WinLabLogo1} />
                      </div>
                      // <div className='d-flex flex-column py-3' >
                      //   <div
                      //     className='row text-center'
                      //     style={{
                      //       height: '150px',
                      //       width: '100%',
                      //       visibility: headerOn ? 'visible' : 'hidden'
                      //     }}
                      //   >
                      //     <div className='col-3 print-header-logo' style={{ overflow: 'hidden', maxHeight: '100%' }}>
                      //       <img src={WinLabLogo} alt='WinLabLogo' style={{ width: '400px', height: '150px', objectFit: 'contain' }} />
                      //     </div>
                      //     <div className='col-9 d-flex justify-content-center align-items-center text-md font-weight-bold'>
                      //       <span className='text-uppercase font-weight-bold' style={{ color: "rgb(107, 188, 220)", fontSize: "40px" }}>Specialist Clinic & Diagnostic Center</span>

                      //     </div>

                      //   </div>
                      //   <p style={{ borderBottomStyle: 'solid', borderWidth: '6px' }}></p>
                      //   <span className=' mx-5 text-lg font-weight-bold align-content-center text-center' style={{ fontSize: "25px", fontWeight: "bold", color: "rgb(99, 178, 209)" }}>
                      //     No (15/16), Marlarmyaing 2<sup>nd</sup> street, 16<sup>th</sup> Quarter, Hlaing township , Yangon.



                      //     Clinic- 09785069884 </span>  <br /> <span style={{ fontSize: "25px", fontWeight: "bold", color: "rgb(99, 178, 209)" }} className=' mx-5 text-lg font-weight-bold align-content-center text-center'>
                      //     {/* <br /> */}
                      //     E-Mail : winspecialistclinic.hlaing@gmail.com , Facebook & Messenger : Win Specialist Clinic and Diagnostic Center</span>
                      // </div>
                    ) : (
                      <div
                        className='row ' style={{
                          height: '4cm',
                          width: '100%',

                        }}>

                      </div>
                    )}


                    <p style={{ textAlign: 'center', height: "5px", maxHeight: "5px", marginTop: '1.5rem' }} className=''>
                      <b>
                        <u className='text-xl'>LABORATORY REPORT</u>
                      </b>
                    </p>
                    <b>
                      <table className='table  mt-5 table-bordered border-bottom-2 border-dark' style={{ height: "150px", maxHeight: "150px", font: '30px' }} >
                        <thead className='bg-white' style={{ outline: "3px solid black" }}>
                          <tr >
                            <TH1>Patient Name:</TH1>
                            <TD1 colSpan='2'>{patientLists.name}</TD1>
                            <TH1>Voucher Id:</TH1>
                            <TD1 colSpan='2'>{labID_VouCode.code}</TD1>
                          </tr>
                          <tr>
                            <TH1>Age & Gender:</TH1>
                            <TD1 colSpan='2'>
                              {calculateAge(patientLists?.dateOfBirth) || patientLists?.age}yrs&nbsp;/ &nbsp;
                              {patientLists.gender}
                            </TD1>
                            <TH1>Registration Date:</TH1>
                            <TD1 colSpan='2'>
                              {labID_VouCode.date
                                ? formatDate(labID_VouCode.date)
                                : ''}
                            </TD1>
                          </tr>
                          <tr>
                            <TH1>Doctor:</TH1>
                            <TD1 colSpan='2'>
                              {labID_VouCode.referDoctor
                                ? labID_VouCode.referDoctor.name
                                : ''}
                            </TD1>
                            <TH1>Reported Date :</TH1>
                            <TD1 colSpan='2'>
                              {PRDate ? formatDate(PRDate) : (
                                <input type='date' className='rounded-3 p-2 d-print-none' onChange={(e) => setRPDate(e.target.value)} />
                              )}

                            </TD1>
                          </tr>
                          <tr>
                            <TH1>Lab ID:</TH1>
                            <TD1 colSpan='2'>
                              {labID_VouCode.labId
                                ? labID_VouCode.labId
                                : '-'}
                            </TD1>
                            <TH1>Clinic :</TH1>
                            <TD1 colSpan='2'>{labID_VouCode.referClinic
                              ? labID_VouCode.referClinic
                              : ''}</TD1>
                          </tr>
                        </thead>
                        <tbody></tbody>
                      </table>
                    </b>
                  </div>

                  {/* ===== CONTENT ===== */}
                  <div className='print-content flex-grow-1'>
                    <div className="">
                      <table className='table voucher-table' style={{ pageBreakInside: "auto", marginTop: "80px" }}>


                        <thead style={{ height: "10px", }} className='bg-white'>
                          {hasImage ? (
                            <tr style={{
                              pageBreakInside: "avoid", pageBreakAfter: "auto", marginBottom: "1px", height: "10px",
                              borderStyle: "solid",
                              borderColor: "black",
                              borderWidth: "1px",
                              outline: "1px solid black"
                            }}>
                              <TH1>Test</TH1>
                              <TH1 className='text-center'>Image</TH1>
                              <TH1>Remark</TH1>
                            </tr>
                          ) : (
                            <tr style={{
                              outline: "1px solid black", borderStyle: "solid",
                              borderColor: "black",
                              borderWidth: "1px"
                            }}>
                              <TH1 >Test</TH1>
                              <TH1>Result</TH1>
                              <TH1>Reference Range</TH1>
                              <TH1>Unit</TH1>
                              <TH1>Remark</TH1>
                            </tr>
                          )}
                        </thead>
                        {filteredVouchers.map(testSelect => (
                          <>

                            <tbody>
                              {testSelect.name.subTestFlag ? (
                                <tr className='voucher-row' style={{ pageBreakInside: "auto", pageBreakAfter: "auto", marginBottom: "1px" }}>
                                  <TD1>
                                    <div className='col-md-12 border-0'>
                                      <p style={{ minHeight: '40px' }}>
                                        <u>
                                          <b>
                                            {testSelect.name.name.includes('NS')
                                              ? testSelect.name.name.replace('NS', '')
                                              : testSelect.name.name}
                                          </b>
                                        </u>
                                      </p>
                                      {/* {
                                testSelect.name.subTest.map((test) => (
                                  <p>{test.name}</p>
                                ))
                              } */}
                                      {testSelect.subTest.map(test => (
                                        <span>
                                          {test !== null ? (
                                            test.type === 'underline' ? (
                                              <p>
                                                <u>
                                                  <b>{test.name}</b>
                                                </u>
                                              </p>
                                            ) : test.type === 'highlight' ? (
                                              <p style={{ color: 'red' }}>
                                                <b>{test.name}</b>
                                              </p>
                                            ) : test.type === 'both' ? (
                                              <p style={{ color: 'red' }}>
                                                <u>
                                                  <b>{test.name}</b>
                                                </u>
                                              </p>
                                            ) : test.type === "multiline" ? (
                                              <p style={{ marginBottom: "45px" }}>{test.name}</p>
                                            ) : (<p>{test.name}</p>)
                                          ) : (
                                            <p>{test.name}</p>
                                          )}{' '}
                                        </span>
                                        // <p>{(test.type === "underline") ? <u> : ""}{test.name}{(test.type === "underline") ? </u> : ""}</p>
                                      ))}
                                    </div>
                                  </TD1>

                                  <TD1>
                                    <div className='col-md-12 border-0'>
                                      <p style={{ height: '40px' }}></p>
                                      {testSelect.subTest.map(test => (
                                        // <p
                                        //   style={{ marginBottom: '6px' }}
                                        // >{(test.result !== null) ? test.result : ""}</p>
                                        <span>
                                          {' '}
                                          {test !== null ? (
                                            test.type === 'underline' ||
                                              test.type === 'highlight' ||
                                              test.type === 'both' ? (
                                              <p style={{ color: 'white' }}>""</p>
                                            ) : test.type === "multiline" ? (<p style={{ marginBottom: "45px" }} >
                                              {' '}
                                              {test.result !== '' ? (
                                                test.result
                                              ) : test.defaultResult !== '' ? (
                                                test.defaultResult
                                              ) : (
                                                <P>-</P>
                                              )}
                                            </p>) : (
                                              <p >
                                                {' '}
                                                {test.result !== '' ? (
                                                  test.result
                                                ) : test.defaultResult !== '' ? (
                                                  test.defaultResult
                                                ) : (
                                                  <P>-</P>
                                                )}
                                              </p>
                                            )
                                          ) : (
                                            ''
                                          )}
                                        </span>
                                      ))}
                                    </div>
                                  </TD1>
                                  <TD1>
                                    <div className='col-md-12 border-0'>
                                      <p style={{ height: '40px' }}></p>
                                      {/* <div style={{ height: '40px' }}></div> */}
                                      {testSelect.subTest.map(test => (
                                        // <p style={{ marginTop: '22px' }}>{test.referenceRange}</p>
                                        <span>
                                          {' '}
                                          {test !== null ? (
                                            test.type === 'underline' ||
                                              test.type === 'highlight' ||
                                              test.type === 'both' ?
                                              <p style={{ color: 'white' }}>""</p>
                                              : ((test.referenceRange !== "") ?
                                                ((test.type === "multiline") ? <p contentEditable="true">{formatString(test.referenceRange)}</p> :
                                                  //   <input
                                                  //   className='border-0'
                                                  //   type='text'
                                                  //   id='subRefRange'
                                                  //   defaultValue={test.referenceRange}
                                                  //   style={{ height: '24px' }}
                                                  // />
                                                  <p contentEditable="true">{test.referenceRange}</p>
                                                ) : <P>-</P>)


                                          ) : (
                                            <p>-</p>
                                          )}
                                        </span>
                                      ))}
                                    </div>
                                  </TD1>

                                  <TD1>
                                    <div className='col-md-12 border-0'>
                                      <p style={{ height: '40px' }}></p>
                                      {testSelect.subTest.map(test => (
                                        // <p style={{ marginTop: '18px' }}>{test.unit}</p>
                                        <span>
                                          {' '}
                                          {test !== null ? (
                                            test.type === 'underline' ||
                                              test.type === 'highlight' ||
                                              test.type === 'both' ? (
                                              <p style={{ color: 'white' }}>""</p>
                                            ) : test.type === "multiline" ? (<p style={{ marginBottom: "45px" }}>
                                              {test.unit === '' ? (
                                                <P>-</P>
                                              ) : (
                                                test.unit
                                              )}
                                            </p>) : (
                                              <p>
                                                {test.unit === '' ? (
                                                  <P>-</P>
                                                ) : (
                                                  test.unit
                                                )}
                                              </p>
                                            )
                                          ) : (
                                            <P>-</P>
                                          )}
                                        </span>
                                      ))}
                                    </div>
                                  </TD1>

                                  <TD1>
                                    <div className='col-md-12 border-0'>
                                      <p style={{ height: '40px' }}></p>
                                      {testSelect.subTest.map(test => (
                                        // <p
                                        //   style={{ marginBottom: '6px' }}
                                        // >{(test.remark !== null) ? test.remark : ""}</p>
                                        <span>
                                          {' '}
                                          {test !== null ? (
                                            test.type === 'underline' ||
                                              test.type === 'highlight' ||
                                              test.type === 'both' ? (
                                              <p style={{ color: 'white' }}>""</p>
                                            ) : test.type === "multiline" ? (<p style={{ marginBottom: "45px" }}>
                                              {test.remark === '' ? (
                                                <P>-</P>
                                              ) : (
                                                test.remark
                                              )}
                                            </p>) : (
                                              <p>
                                                {test.remark === '' ? (
                                                  <P>-</P>
                                                ) : (
                                                  test.remark
                                                )}
                                              </p>
                                            )
                                          ) : (
                                            ''
                                          )}
                                        </span>
                                      ))}
                                    </div>
                                  </TD1>
                                </tr>
                              ) : (
                                <tr key={testSelect._id} style={{ pageBreakInside: "auto", pageBreakAfter: "auto" }}>
                                  {testSelect.img ? (
                                    <>
                                      <TD1>
                                        {testSelect.name.name.includes('NS')
                                          ? testSelect.name.name.replace('NS', '')
                                          : testSelect.name.name}
                                      </TD1>
                                      <TD1>
                                        <img src={`http://wincliniclabbackend.kwintechnologies.com:7070/static/cherry-k/${testSelect?.img?.imgUrl}`} width='300px' height='300px' />
                                      </TD1>
                                      <TD1>{testSelect.remark}</TD1>
                                    </>

                                  ) : (
                                    <>
                                      <TD1>
                                        {testSelect.name.name.includes('NS')
                                          ? testSelect.name.name.replace('NS', '')
                                          : testSelect.name.name}
                                      </TD1>
                                      <TD1>{testSelect.result}</TD1>

                                      <TD1 className='w-full'>
                                        {testSelect.name.specialComment ? (
                                          'See Below'
                                        ) : (
                                          <div>
                                            {testSelect.name.referenceRange.map(refer => (
                                              <p key={refer._id}>
                                                {/* {refer.gender} &nbsp;
                                    {refer.from}-{refer.to} &nbsp; */}
                                                {/* {refer.refRange} */}
                                                <input
                                                  type='text'
                                                  id='refRange'
                                                  name='refRange'
                                                  defaultValue={refer.refRange}
                                                  style={{ borderStyle: 'hidden', width: '300px' }}
                                                />
                                              </p>
                                            ))}
                                          </div>
                                        )}
                                      </TD1>

                                      <TD1>
                                        {testSelect.name.specialComment ? (
                                          'See Below '

                                        ) : (
                                          <div className='w-full'>
                                            {testSelect.name.referenceRange.map(refer => (
                                              <p key={refer._id}>{refer.unit}</p>
                                            ))}
                                          </div>
                                        )}
                                      </TD1>
                                      <TD1>{testSelect.remark}</TD1>
                                    </>

                                  )}



                                </tr>
                              )}
                            </tbody>
                          </>

                        ))}
                      </table>
                    </div>


                    {textArea ? (
                      <div className='row '>
                        <label>Comment</label>
                        <p>{textArea}</p>
                      </div>
                    ) : (
                      ''
                    )}

                    <div className='px-3 py-2 '>
                      <div className='row'>
                        {filteredVouchers.map(specDecode => (
                          <div className='col-md-6' key={specDecode._id}>
                            <h6 className='text-bold text-decoration-underline'>
                              {specDecode.name.specialFlag
                                ? `${specDecode.name.name} Reference Range`
                                : ''}
                            </h6>
                            <p>{formatString(specDecode.name.specialComment)}</p>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>


                  {/* {showBottom ? ( */}


                  {/* Spacer for footer positioning */}
                  {/* <div style={{ flex: 1 }}></div> */}
                  {/* ===== FOOTER ===== */}
                  <div className=' last-page mt-auto'>
                    <div id="print-footer">
                      {refOn === true ? (

                        <div className='absolute bottom-0 w-full'>
                          {/* Fixed Signature Section at Bottom */}
                          <div className="row w-full">
                            <div className="col-5 text-center" style={{ marginTop: '60px', fontSize: '20px' }}>
                              <span>Laboratory Technician</span>
                            </div>
                            <div className='col-2'></div>
                            <div
                              className="col-5 text-center"
                              style={{ textAlign: 'center', color: 'blue' }}
                            >
                              <span>
                                {selectedPatho ? (
                                  selectedPatho._id === '6a38def2b04b6ad89e41db77' ? (
                                    <>
                                      <img src={DrAP} width="80px" />
                                      <br />
                                    </>
                                  ) 
                                   : selectedPatho._id === '64663367e9a0fb9010b07fda' ? (
                                    <>
                                      <img src={Hnin} width="150px" />
                                      <br />
                                    </>
                                  ) : selectedPatho._id === '66954698d578da4524283e33' ? (
                                    <>
                                      <img src={Sign} width="60px" />
                                      <br />
                                    </>
                                  ) : null
                                ) : (
                                  <>
                                    <img src={DrAP} width="60px" />
                                    <br />
                                  </>
                                )}
                                <b>{selectedPatho ? selectedPatho?.name : referDoctorLists[1]?.name}</b>
                                <br />
                                {selectedPatho ? selectedPatho.position : referDoctorLists[1]?.position}
                                <br />
                                {selectedPatho ? selectedPatho.education : referDoctorLists[1]?.education}
                                <br />
                                Win Diagnostic Center
                              </span>
                            </div>
                          </div>

                          {/* Quote Section */}
                          <div className="col-12 text-center py-4 mt-5" style={{ fontSize: "25px", fontWeight: "bold", color: "rgb(0, 68, 103)" }}>
                            <span>" We care about the Reports and the Patients behind the Reports. "</span>
                          </div>
                        </div>

                      ) : (
                        <>



                          <div className='row mx-3 mb-5 text-center absolute bottom-0 mt-5' >
                            <div className="col-12 text-center py-4" style={{ fontSize: "25px", fontWeight: "bold", color: "rgb(0, 68, 103)" }}>
                              <span>" We care about the Reports and the Patients behind the Reports. "</span>
                            </div>

                          </div>




                        </>

                      )}
                    </div>
                  </div>


                  {/* ===== STYLES ===== */}
                  <style>
                    {`
        /* General layout */
        .print-header {
          text-align: center;
        }
        .print-content {
          flex: 0 0 auto;
        }
        table {
          width: 100%;
          border-collapse: collapse;
        }
        th, td {
  
          padding: 6px;
          text-align: left;
        }
        #print-footer {
          text-align: center;
          padding-top: 10px;
        }

        /* Print-specific rules */
        @media print {
          body {
            margin: 0;
            padding: 0;
            overflow: visible !important;
            height: 100%;
          }
          #print {
            position: absolute;
            top: 0 !important;
            left: 0 !important;
            display: flex;
            flex-direction: column;
            height: 100%;
          }
          .print-header-logo {
            margin-top: 5px;
          }
          .print-content {
            height: auto !important;
            overflow: visible !important;
          }
          thead {
            display: table-header-group;
          }
          tfoot {
            display: table-footer-group;
          }
  #print-footer {
    position: static !important;

    width: 100%;
    padding: 10px 0;
    margin-top: auto ;
    page-break-inside: avoid;
  }


        }
        `}
                  </style>

                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='row'>

          <div className='offset-1 col-md-3 mb-4' style={{ marginTop: '1em' }}>
            <label>Pathologist</label>&nbsp;
            <label>On</label>&nbsp;
            <input
              type='radio'
              id='on'
              name='reference'
              onChange={() => setRefOn(true)}
            />
            &nbsp; &nbsp;
            <label>Off</label>&nbsp;
            <input
              type='radio'
              id='off'
              name='reference'
              onChange={() => setRefOn(false)}
            />
            <div className='col-6'>
              <select
                className='form-control'
                name='pathologist'
                id='pathologist'
                onChange={e => handlePathoChange(e.target.value)}
              >
                <option hidden>{referDoctorLists[0]?.name}</option>
                {referDoctorLists.map(option => (
                  <option value={option._id}>{option.name}</option>
                ))}
              </select>
            </div>
          </div>
          <div className='col-md-3 mb-4' style={{ marginTop: '2em' }}>
            <label>Tests Result</label>&nbsp;
            {/* <input type='radio' id='on' name='result' onChange={ResOnCheck} />
            &nbsp; &nbsp;
            <label>Off</label>&nbsp;
            <input type='radio' id='off' name='result' onChange={ResOffCheck} /> */}
            <div className='col-6'>
              {voucherLists.map(vou => (
                <div>
                  <input
                    type='checkbox'
                    id={vou._id}
                    name={vou.name.name}
                    value={vou._id}
                    onChange={(e) => handleChange(e)}
                  />
                  <label htmlFor={vou.name.name}>{vou.name.name}</label>
                </div>
              ))}
            </div>
          </div>

          <div className='col-md-3 mb-4' style={{ marginTop: '2em' }}>
            <label>Header On</label>&nbsp;
            <input
              type='radio'
              id='on'
              name='amoper'
              onChange={handleOnCheck}
            />
            &nbsp; &nbsp;
            <label>Off</label>&nbsp;
            <input
              type='radio'
              id='off'
              name='amoper'
              onChange={handleOffCheck}
            />
          </div>

        </div>
      </div>
      <div className='d-flex justify-content-center'>
        {/* <ReactToPrint
              trigger={() => ( */}
        <button
          className='btn btn-success mt-3 mb-4'
          // handleBottomChange
          onClick={handleShowModalBox}
        >
          Print
        </button>
        {/* )}
              content={() => componentRef}
              // pageStyle={`@page { size: ${getContentSize().width}px ${getContentSize().height}px; }`}
            /> */}
      </div>

      <ConfirmResultDialog open={showDialog} close={() => setShowDialog(false)} handleConfirm={handleBottomChange} vouchers={filteredVouchers} />
    </div>
  )
}

export default TestVoucherPrint
